module.exports = __webpack_public_path__ + "img/all_jobs_jobmule_home.297130f9.jpg";